import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RosterGuard } from './guards/roster.guard';
import { SetupGuard } from './guards/setup.guard';
import { SurveyGuard } from './guards/survey.guard';
import { CheckVersionPageModule } from './pages/roster/check-version/check-version.module';

const routes: Routes = [
  {
    path: 'signup',
    loadChildren: () => import('./pages/setup/signup/signup.module').then((m) => m.SignupPageModule),
    canActivate: [SetupGuard]
  },
  // {
  //     path: 'login',
  //     loadChildren: () => import('./pages/setup/login/login.module').then(m => m.LoginPageModule),
  //     canActivate: [SetupGuard],
  //     runGuardsAndResolvers: 'always'
  // },
  {
    path: 'locale',
    loadChildren: () => import('./pages/setup/locale/locale.module').then((m) => m.LocalePageModule),
    canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/setup/terms/terms.module').then((m) => m.TermsPageModule),
    canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'survey/:surveyType/:surveyId/:pageName',
    loadChildren: () => import('./pages/survey/survey/survey.module').then((m) => m.SurveyPageModule),
    canActivate: [SurveyGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'person',
    loadChildren: () => import('./pages/setup/person/person.module').then((m) => m.PersonPageModule),
    canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'persons-setup',
    loadChildren: () => import('./pages/setup/persons-setup/persons-setup.module').then((m) => m.PersonsSetupPageModule),
    canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'unavailable/:key',
    loadChildren: () => import('./pages/setup/unavailable/unavailable.module').then((m) => m.UnavailablePageModule),
    // canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'change-platform',
    loadChildren: () => import('./pages/setup/change-platform/change-platform.module').then((m) => m.ChangePlatformPageModule),
    canActivate: [SetupGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'dashboard',
    loadChildren: async () => (await import('./pages/roster/dashboard/dashboard.module')).DashboardPageModule,
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    ...CheckVersionPageModule.route,
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'permission-error/:permissions',
    loadChildren: () => import('./pages/roster/permission-error/permission-error.module').then((m) => m.PermissionErrorPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/roster/home/home.module').then((m) => m.HomePageModule),
    canActivate: [RosterGuard]
  },
  {
    path: 'dash/:personId',
    loadChildren: () => import('./pages/roster/dash/dash.module').then((m) => m.DashPageModule),
    canActivate: [RosterGuard]
  },
  {
    path: 'trips/:personId/:ymd',
    loadChildren: () => import('./pages/roster/trips/trips.module').then((m) => m.TripsPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'add-start/:surveyId/:personId',
    loadChildren: () => import('./pages/add/add-start/add-start.module').then((m) => m.AddStartPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'add-stop/:surveyId/:personId',
    loadChildren: () => import('./pages/add/add-stop/add-stop.module').then((m) => m.AddStopPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'add-times/:surveyId/:personId',
    loadChildren: () => import('./pages/add/add-times/add-times.module').then((m) => m.AddTimesPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'add-another/:surveyId/:personId',
    loadChildren: () => import('./pages/add/add-another/add-another.module').then((m) => m.AddAnotherPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'map-route/:surveyId/:personId',
    loadChildren: () => import('./pages/roster/map-route/map-route.module').then((m) => m.MapRoutePageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'verify/:surveyId/:personId',
    loadChildren: () => import('./pages/edit/verify/verify.module').then((m) => m.VerifyPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'roster',
    loadChildren: () => import('./pages/browser/roster/roster.module').then((m) => m.RosterPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'log',
    loadChildren: () => import('./pages/roster/log/log.module').then((m) => m.LogPageModule)
  },
  {
    path: 'mode-change/:surveyId/:personId',
    loadChildren: () => import('./pages/edit/mode-change/mode-change.module').then((m) => m.ModeChangePageModule)
  },
  {
    path: 'vet/:surveyId/:personId',
    loadChildren: () => import('./pages/edit/vet/vet.module').then((m) => m.VetPageModule)
  },
  {
    path: 'unsupported',
    loadChildren: () => import('./pages/browser/unsupported/unsupported.module').then((m) => m.UnsupportedPageModule)
  },
  {
    path: 'call-center',
    loadChildren: () => import('./pages/setup/call-center/call-center.module').then((m) => m.CallCenterPageModule)
  },
  {
    path: 'trips-ld',
    loadChildren: () => import('./pages/ld/trips-ld/trips-ld.module').then((m) => m.TripsLdPageModule),
    canActivate: [RosterGuard]
  },
  {
    path: 'vet-ld/:surveyId/:personId',
    loadChildren: () => import('./pages/ld/vet-ld/vet-ld.module').then((m) => m.VetLdPageModule),
    canActivate: [RosterGuard]
  },
  {
    path: 'map-region/:surveyId/:personId',
    loadChildren: () => import('./pages/ld/map-region/map-region.module').then((m) => m.MapRegionPageModule),
    canActivate: [RosterGuard],
    runGuardsAndResolvers: 'always'
  },

  {
    path: '',
    redirectTo: 'signup',
    pathMatch: 'full'
  },
  // TODO - separate guard for wildcard that automatically runs registration.initalize?
  {
    path: '**',
    loadChildren: () => import('./pages/setup/signup/signup.module').then((m) => m.SignupPageModule),
    canActivate: [SetupGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
